import * as React from 'react';

function SvgBookingListLink(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.003 13.425h1.011l-.425 1.206h-1.79V9.178h-.712c-.59 0-1.08-.47-1.087-1.06a1.07 1.07 0 01.315-.77L7.217.45a.527.527 0 01.743 0l3.36 3.358-.897.807L7.59 1.784 1.396 7.973h1.607v5.452zm8.284.067a.12.12 0 01.085.035l.596.597a.12.12 0 010 .17l-1.75 1.75a3.259 3.259 0 01-4.61 0 3.257 3.257 0 010-4.61l1.75-1.75a.121.121 0 01.17 0l.6.599a.121.121 0 010 .17l-1.751 1.751a2.164 2.164 0 000 3.074c.895.896 2.263.81 3.074 0l1.75-1.751a.12.12 0 01.086-.035zm-.63-7.107a3.257 3.257 0 014.611 0 3.262 3.262 0 010 4.612l-1.75 1.751a.121.121 0 01-.171 0l-.6-.6a.12.12 0 010-.17l1.751-1.75c.81-.811.897-2.178 0-3.074a2.164 2.164 0 00-3.073 0l-1.751 1.75a.121.121 0 01-.17 0l-.599-.598a.121.121 0 010-.17l1.753-1.75zm1.174 2.69c.031 0 .062.013.085.036l.595.596a.121.121 0 010 .17L9.1 13.29a.121.121 0 01-.17 0l-.597-.597a.12.12 0 010-.17l3.412-3.411a.121.121 0 01.086-.035z"
      />
    </svg>
  );
}

export default SvgBookingListLink;
